<div class="dummyImage" :style="renderStyle"></div>
